export default "__VITE_ASSET__e9ceb2df__"